import React, {useMemo} from 'react'
import {Block, Col, Row} from 'jsxstyle'
import {XpertKnowledgeDto} from '../../../services/XpertKnowledge/type'
import XpertKnowledgeUnPlublishedBlock from './XpertKnowledgeUnPlublishedBlock'
import i18n from '../../../common/i18n'

interface UnpublishedTutorialsSectionProps {
  tutorials: XpertKnowledgeDto[]
  selectedId?: string
  onTutorialClick: (tutorial: XpertKnowledgeDto) => void
}

const UnpublishedTutorialsSection: React.FC<UnpublishedTutorialsSectionProps> = ({tutorials, selectedId, onTutorialClick}) => {
  const unpublishedTutorials = useMemo(() => {
    const UNPUBLISHED_STATUS_PRIORITY = [
      'REFUSED',
      'IN_REVIEW',
      'DRAFT',
      'IN_GENERATION',
      'WAITING_FOR_FILE',
      'FAILED_GENERATION',
      'FAILED_RECEIVE_FILE',
    ]

    return tutorials
      .filter((xk) => xk.publishTutorial?.status !== 'PUBLISHED')
      .sort((a, b) => {
        const aStatus = a.publishTutorial?.status ?? a.status
        const bStatus = b.publishTutorial?.status ?? b.status

        const aIndex = UNPUBLISHED_STATUS_PRIORITY.indexOf(aStatus)
        const bIndex = UNPUBLISHED_STATUS_PRIORITY.indexOf(bStatus)

        const aPriority = aIndex === -1 ? 999 : aIndex
        const bPriority = bIndex === -1 ? 999 : bIndex

        if (aPriority !== bPriority) {
          return aPriority - bPriority
        }

        const aCreatedAt = new Date(a.createdAt || 0).getTime()
        const bCreatedAt = new Date(b.createdAt || 0).getTime()

        return bCreatedAt - aCreatedAt
      })
  }, [tutorials])

  if (unpublishedTutorials.length === 0) {
    return null
  }

  return (
    <Col gap="10px">
      <Block fontSize="18px" fontWeight={600} padding="8px 0">
        {i18n.t('xk.list.unpublished.title')}
      </Block>

      <Row gap="16px" whiteSpace="nowrap" width="calc(100vw - 200px)" overflowX="scroll">
        {unpublishedTutorials.map((tutorial) => (
          <XpertKnowledgeUnPlublishedBlock
            key={tutorial.id}
            xpertKnowledge={{...tutorial, isSelected: tutorial.id === selectedId}}
            onClick={() => onTutorialClick(tutorial)}
          />
        ))}
      </Row>
    </Col>
  )
}

export default UnpublishedTutorialsSection
